'use client'

import { useSyncExternalStore } from 'react'
import { useTheme } from '@/hooks/use-theme'
import { calendlyEmbedUrl } from '@/lib/site'

const noSubscription = () => () => {}

/**
 * The Calendly scheduler in the site's theme (calendlyEmbedUrl). The server
 * can't know the theme, so the page loads the light embed and a dark-mode
 * visitor's frame switches to the dark one as the page hydrates, long before
 * Calendly paints. A theme change reloads the scheduler in the new colours.
 * The page's query string, read the same way, picks the event (`event=demo`
 * for the KAI Vault demo) and passes its campaign tags to Calendly.
 */
export function CalendlyFrame({ title }: { title: string }) {
  const theme = useTheme() ?? 'light'
  const search = useSyncExternalStore(noSubscription, () => window.location.search, () => '')
  return <iframe src={calendlyEmbedUrl(theme, search)} title={title} loading="eager" />
}
